export const API_FAKE = 'http://ajec.ca/front-end/api/';

export const IMAGE_URL = 'http://ajecapi.mehdisaedi.com/public/';
// export const IMAGE_URL = 'http://api.mehdisaedi.com/';
// export const IMAGE_URL = 'http://localhost:8000/';
// export const API_URL = 'http://api.mehdisaedi.com/api/v1/';
export const API_URL = IMAGE_URL + 'api/v1/';

export const MAP_API_KEY = 'AIzaSyBk1Y3RjIlfRt5IyiK_SXuRwuGSQHgSsus ';



// WEBPACK FOOTER //
// ./src/config/Config.js